import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, message, Row, Spin } from 'antd';
import { connect } from 'react-redux';
import './TsAgreementWithdraw.scss';
import { goToAccountGOSPreTradingAgreementDetails } from '../../utils/gotoLink';
import * as agreementWithdrawViewActions from '../../actions/actionCreators/agreementWithdrawViewActionCreators';
import { confirmWithdrawAssignment } from '../../actions/actionCreators/agreementWithdrawViewActionCreators';
import { getAgreementWithdrawData } from '../../reducers/agreementWithdrawViewReducer';
import { Form, Field } from 'react-final-form';
import { RadioField } from '../../atoms';
import { FormActions } from '../../components';
import FormStateToRedux from '../FormStateToRedux';
import { FROM_AGREEMENT_WITHDRAW_ASSIGNMENT } from '../../constants/formKeys';
import { formAssignmentFields } from '../../constants/forms/formAssignment';

export class TsAgreementWithdrawAssignment extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    assignment: PropTypes.object.isRequired,
    withdrawal: PropTypes.object.isRequired,
    hideModal: PropTypes.func.isRequired,
    fetchWithdrawal: PropTypes.func.isRequired,
    confirmWithdrawAssignment: PropTypes.func.isRequired,
    isConfirmable: PropTypes.bool.isRequired,
    search: PropTypes.func,
    searchAgreements: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  componentDidMount = () => {
    const { assignment, fetchWithdrawal } = this.props;
    fetchWithdrawal(assignment.sourceId);
  };

  onSubmit = async (values) => {
    const { assignment, t, onSuccess, hideModal } = this.props;
    const result = await this.props.confirmWithdrawAssignment(
      assignment.id,
      values.confirm
    );
    if (!result?.error) {
      message.success(t('agreements.withdraw.performSuccess'));
      onSuccess?.();
      hideModal();
    }
  };

  openAgreement(agreementId) {
    this.props.hideModal();
    goToAccountGOSPreTradingAgreementDetails(
      this.props.registerCode,
      agreementId
    );
  }

  renderRow = (label, value) => (
    <div>
      <span>{label}: </span>
      <span>{value}</span>
    </div>
  );

  render() {
    const { t, withdrawal, assignment, hideModal, isConfirmable } = this.props;

    const isLoading = Object.keys(withdrawal).length === 0;
    if (isLoading) return <Spin />;

    return (
      <Form
        onSubmit={this.onSubmit}
        render={({ handleSubmit, values }) => {
          const isConfirmAssignment = values[formAssignmentFields.CONFIRM];
          return (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FROM_AGREEMENT_WITHDRAW_ASSIGNMENT} />
              <Row gutter={32}>
                <Col span={24} className="detail-container">
                  <div>
                    <span>{t('assignments.withdraw.agreementId')}: </span>
                    <Button
                      type="link"
                      onClick={() =>
                        this.openAgreement(withdrawal.tsAgreementId)
                      }
                    >
                      {withdrawal.tsAgreementId}
                    </Button>
                  </div>
                  {this.renderRow(
                    t('assignments.withdraw.counterpartyName'),
                    withdrawal.counterpartyName
                  )}
                  {this.renderRow(
                    t('assignments.withdraw.createdDate'),
                    withdrawal.createdDate
                  )}
                  {this.renderRow(
                    t('assignments.withdraw.dueDate'),
                    assignment.dueDate
                  )}
                  {this.renderRow(
                    t('assignments.withdraw.effectiveDate'),
                    withdrawal.effectiveDate
                  )}
                  <br />
                  <div style={{ paddingBottom: 5 }}>
                    <span>
                      <strong>{t('assignments.withdraw.reason')}:</strong>
                    </span>
                  </div>
                  <textarea
                    className={'ant-input'}
                    rows={16}
                    value={withdrawal.reason}
                    readOnly={true}
                  />
                </Col>
              </Row>
              {isConfirmable && (
                <Row gutter={32}>
                  <Col span={12}>
                    <Field
                      className="radio-field pt-5"
                      name={formAssignmentFields.CONFIRM}
                      component={RadioField}
                      options={[
                        {
                          value: false,
                          label: t('assignments.withdraw.reject'),
                          tooltip: t('assignments.withdraw.rejectTooltip'),
                        },
                        {
                          value: true,
                          label: t('assignments.withdraw.confirm'),
                          tooltip: t('assignments.withdraw.confirmTooltip'),
                        },
                      ]}
                    />
                  </Col>
                </Row>
              )}
              {isConfirmable && (
                <FormActions>
                  <Button onClick={hideModal}>
                    {t('assignments.confirm.cancel')}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={isConfirmAssignment === undefined}
                  >
                    {t('assignments.confirm.confirm')}
                  </Button>
                </FormActions>
              )}
            </form>
          );
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  withdrawal: getAgreementWithdrawData(state).toJS(),
});

const mapDispatchToProps = {
  fetchWithdrawal: agreementWithdrawViewActions.fetchWithdrawal,
  confirmWithdrawAssignment,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TsAgreementWithdrawAssignment);
